// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"62b1b539","732":"75f0be84","977":"ebc019f1"}[chunkId] + ".chunk.js";
};